import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";

const quoteStyle = {
  ...imagesStyle,
  container: {
    margin: "15px",
  },
  card: {
    border: "0",
    marginBottom: "30px",
    marginTop: "30px",
    paddingBottom: "15px",
    borderRadius: "6px",
    color: "rgba(0, 0, 0, 0.87)",
    background: "#fff",
    width: "100%",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem",
    transition: "all 300ms linear",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardHeader: {
    textAlign: "center",
    fontSize: "6em",
    fontWeight: "800",
    marginTop: "0",
    marginBottom: "0",
    paddingTop: "15px",
    paddingBottom: "0px",
    lineHeight: "0em"
  },
  cardBody: {
    fontStyle: "italic",
    fontSize: "1.25rem",
    textAlign: "left",
  },
  cardCarousel: {
    overflow: "hidden"
  },
  quotationMark: {
    textShadow: "1px 1px 2px grey"
  },
  smallTitle: {
    display: "inline-block",
    color: "#6c757d",
    lineHeight: "1.1em",
    "& a": {
      color: "#6c757d",
      fontStyle: "italic"
    }
  },
  authorImageContainer: {
    marginBottom: "-40px"
  }
};

export default quoteStyle;
